module.exports = __webpack_public_path__ + "img/home-left-img.4bc30d68.png";